import http from "./HttpService";

const BASE_SERVICE_URL = "customer-service";

export default {
  validateCustomerRegistration(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/api/v3/customer/validate/register`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  sendOtp(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/api/v3/customer/otp`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  sendOtpViaEmail(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/api/v3/customer/otp/email`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  verifyOtp(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/api/v3/customer/otp/verify/mobile/advance`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  verifyOtpEmail(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/api/v3/customer/otp/verify/email/advance`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  setPin(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/customer/pin/set",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  forgotPinMobile(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/api/v3/customer/forgot-pin/mobile`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  forgotPinEmail(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/api/v3/customer/forgot-pin/email`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  updatePin(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/customer/pin/update",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getCustomerProfile(request) {
    return new Promise((resolve, reject) => {
      http
        .get(BASE_SERVICE_URL + "/customer/profile", request.header)
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  updateCustomerProfile(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/customer/profile",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  updateCustomerName(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/customer/name/update`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getCities(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/customer/cities",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getProvinces(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          BASE_SERVICE_URL + "/customer/provinces",
          request.header,
          request.payload
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getSurveyStatus (request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `${BASE_SERVICE_URL}/customer/survey/verify`,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        })
    });
  },
  saveBillingInfo(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/customer/billing-info/save",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  deleteAccount(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/api/v3/customer/deactivate-account`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  validateUserPin(request) {
    return new Promise((resolve, reject) => {
      http.post(
        `${BASE_SERVICE_URL}/customer/pin/validate`,
        request.payload,
        request.header
      )
      .then(response => {
        return resolve(response);
      })
      .catch((status, errors) => {
        reject(status, errors);
      });
    });
  },
  validateNewMobileNumber(request) {
    return new Promise((resolve, reject) => {
      http.get(
        `${BASE_SERVICE_URL}/customer/mobile/update/validate/${request.payload.mobile}`,
        request.header
      )
      .then(response => {
        return resolve(response);
      })
      .catch((status, errors) => {
        reject(status, errors);
      });
    });
  },
  sendCustomerNewNumberOtp(request) {
    return new Promise((resolve, reject) => {
      http.post(
        `${BASE_SERVICE_URL}/api/v3/customer/otp/sms`,
        request.payload,
        request.header
      )
      .then(response => {
        return resolve(response);
      })
      .catch((status, errors) => {
        reject(status, errors);
      });
    });
  },
  updateCustomerMobileNumber(request) {
    return new Promise((resolve, reject) => {
      http.post(
        `${BASE_SERVICE_URL}/api/v3/customer/update/mobile-number`,
        request.payload,
        request.header
      )
      .then(response => {
        return resolve(response);
      })
      .catch((status, errors) => {
        reject(status, errors);
      });
    });
  },
  getSpecialDiscountList(request) {
    return new Promise((resolve, reject) => {
      http.get(
        `${BASE_SERVICE_URL}/customer/special_discount/list/${request.uuid}`,
        request.header
      )
      .then(response => {
        return resolve(response);
      })
      .catch((status, errors) => {
        reject(status, errors);
      });
    });
  },
  uploadSpecialDiscount(request) {
    return new Promise((resolve, reject) => {
      http.post(
        `${BASE_SERVICE_URL}/customer/special_discount/upload`,
        request.payload,
        request.header
      )
      .then((response) => resolve(response))
      .catch((status, error) => reject(status, error));
    });
  }
};
